import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import BusinessHeader from "components/Business/BusinessHeader";

import * as businessReducer from "containers/Business/BusinessReducer";
import * as setupReducer from "containers/Setup/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as consumerReducer from "containers/Consumer/reducer";

class BusinessHeaderContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {} = this.props;

    return <BusinessHeader {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateCurrentStep: (stepId) => dispatch(businessReducer.updateCurrentStep(ownProps.id, stepId)),
    updateLabel: (label) => dispatch(setupReducer.updateLabel(ownProps.id, label)),
    updateProjectName: (name) => dispatch(projectReducer.updateProjectName(ownProps.id, name)),
    updateIsEditBlueprint: (value) => dispatch(businessReducer.updateIsEditBlueprint(ownProps.id, value)),
    updateIsAudit: (isAudit) => dispatch(businessReducer.updateIsAudit(ownProps.id, isAudit)),
    saveBlueprint: () => dispatch(businessReducer.saveBlueprint(ownProps.id)),
    getBlueprint: (blueprintId) => dispatch(businessReducer.getBlueprint(blueprintId)),

    updateProjectId: (projectId) => dispatch(consumerReducer.updateProjectId(projectId))
  };
};

const mapStateToProps = (state, ownProps) => {
  const blueprintId =
    ownProps.id === "new"
      ? setupReducer.getBlueprintId(state, ownProps.id)
      : projectReducer.getBlueprintId(state, ownProps.id);

  return {
    isEditBlueprint: businessReducer.getIsEditBlueprint(state, ownProps.id),
    isForecast: projectReducer.getIsForecastProject(state, ownProps.id),
    isSavingBlueprint: businessReducer.getIsSavingBlueprint(state, ownProps.id),
    isAudit: businessReducer.getIsAudit(state, ownProps.id),
    currentStep: businessReducer.getCurrentStep(state, ownProps.id),
    label:
      ownProps.id === "new" ? setupReducer.getLabel(state, "new") : projectReducer.getProjectName(state, ownProps.id),
    createdDate: projectReducer.getCreatedDate(state, ownProps.id),
    hasSplits: projectReducer.getHasSplits(state, ownProps.id),

    blueprintId: blueprintId,
    blueprint: blueprintReducer.getBlueprint(state, blueprintId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(BusinessHeaderContainer);
